import { render } from "./WordpressView.vue?vue&type=template&id=bdffc5e2"
import script from "./WordpressView.vue?vue&type=script&lang=js"
export * from "./WordpressView.vue?vue&type=script&lang=js"

import "./WordpressView.vue?vue&type=style&index=0&id=bdffc5e2&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__